import CustomFieldManager from "../../Manager/CustomFieldManager"
import TemplateSettingsManager from "../../Manager/TemplateSettingsManager"
import { getLocalisedText } from "../../Translate/LanguageManager"
import Utility, { convertDateFromERPFormatToDocFormat, getCapitalized, getConvertedDate, getIsCreditNote, getIsDebitNote, getIsDebitOrCreditNote, getIsExpenseOrDeposit } from "../../Utilities/Utility"
import Address from "../Address"
import AddressParser, { AddressType, OwnerType } from "../AddressParser"
import DataParser from "../DataParser"
import LineItemsParser from "../LineItemsParser"
import TenantParser from "../TenantParser"

export default class AccountParser {
    static parseData(dataFromAPI, templateDataToReturn) {

        //custom field
        templateDataToReturn.customFields = dataFromAPI.customFields
        CustomFieldManager.setCustomFields(dataFromAPI.customFields)
        templateDataToReturn = DataParser.assignCustomFieldValue(templateDataToReturn)

         //company name
        templateDataToReturn.companyName = getCapitalized(dataFromAPI.companyName)
        //handling debit note name
        if (getIsDebitNote(dataFromAPI.type)) {
            templateDataToReturn.companyName = getCapitalized(dataFromAPI.clientName)
        }

        templateDataToReturn.tenantInfo = dataFromAPI.tenantInfo;
        //company address
        var fromAddressObj = undefined
        var preferAddress = AddressParser.getTenantAddressFromApi(undefined, dataFromAPI.tenantInfo)
        if (preferAddress !== undefined) {
            fromAddressObj = new Address(undefined, preferAddress, dataFromAPI.pan, dataFromAPI.tenantInfo.gstin, dataFromAPI.tenantInfo.contactNumber, undefined, OwnerType.tenant)
        }

        if (getIsDebitOrCreditNote(templateDataToReturn.type)) {
            if(dataFromAPI.fromAddress !== undefined && dataFromAPI.fromAddress !== null) {
                if (getIsCreditNote(templateDataToReturn.type)) {
                    fromAddressObj = new Address(undefined, dataFromAPI.fromAddress, dataFromAPI.pan, dataFromAPI.tenantInfo.gstin, dataFromAPI.tenantInfo.contactNumber, undefined, OwnerType.tenant)
                    // Set PAN and CIN for credit notes
                    fromAddressObj.panIndia = dataFromAPI.tenantInfo?.panIndia ?? ''
                    fromAddressObj.cinIndia = dataFromAPI.tenantInfo?.cinIndia ?? ''
                }
                else if (getIsDebitNote(templateDataToReturn.type)) {
                    fromAddressObj = new Address(undefined, dataFromAPI.fromAddress, dataFromAPI.pan, dataFromAPI.contactInfo.gstin, dataFromAPI.contactInfo.contactNumber, undefined, OwnerType.contact)
                    // Set PAN and CIN for debit notes
                    fromAddressObj.panIndia = dataFromAPI.contactInfo?.pan ?? ''
                    fromAddressObj.cinIndia = dataFromAPI.contactInfo?.cin ?? ''
                }

                
            }
        }
        templateDataToReturn.fromObj = fromAddressObj
        templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.from, templateDataToReturn)

        // billing to address
        var clientBillToAddressObj = undefined
        if (dataFromAPI.contactInfo !== undefined && dataFromAPI.contactInfo !== null) {
            if (dataFromAPI.contactInfo.billingAddress !== undefined && dataFromAPI.contactInfo.billingAddress !== null) {
                // For Debit Notes: Bill To should be tenant details, for others use contact details
                if (getIsDebitNote(templateDataToReturn.type)) {
                    clientBillToAddressObj = new Address(dataFromAPI.companyName, dataFromAPI.contactInfo.billingAddress, dataFromAPI.pan, dataFromAPI.tenantInfo.gstin, dataFromAPI.tenantInfo.contactNumber, undefined, OwnerType.tenant)
                    // Set PAN and CIN for billing address (tenant details for debit notes)
                    clientBillToAddressObj.panIndia = dataFromAPI.tenantInfo?.panIndia ?? ''
                    clientBillToAddressObj.cinIndia = dataFromAPI.tenantInfo?.cinIndia ?? ''
                } else {
                    clientBillToAddressObj = new Address(dataFromAPI.clientName, dataFromAPI.contactInfo.billingAddress, dataFromAPI.contactInfo.pan, dataFromAPI.contactInfo.gstin, dataFromAPI.contactInfo.contactNumber, dataFromAPI.contactInfo.documentSequenceCode, OwnerType.contact)
                    // Set PAN and CIN for billing address (for credit notes)
                    if (getIsCreditNote(templateDataToReturn.type)) {
                        clientBillToAddressObj.panIndia = dataFromAPI.contactInfo?.pan ?? ''
                        clientBillToAddressObj.cinIndia = dataFromAPI.contactInfo?.cin ?? ''
                    }
                }
            }
        }
        templateDataToReturn.clientBillToAddressObj = clientBillToAddressObj
        templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.billTo, templateDataToReturn)

        // shipping to address
        templateDataToReturn.clientShipToAddressObj = undefined
        if (getIsExpenseOrDeposit(dataFromAPI.type)) {
            templateDataToReturn.clientShipToAddress = this.get_CN_DN_Payment_Detail(dataFromAPI)
        }

        //ref number
        templateDataToReturn.refNumber = dataFromAPI.refNumber

        //start date
        templateDataToReturn.date = getConvertedDate(convertDateFromERPFormatToDocFormat(dataFromAPI.date), templateDataToReturn.dateFormat)

        //due date
        if (dataFromAPI.referenceDate !== undefined && dataFromAPI.referenceDate !== null && dataFromAPI.referenceDate !== '') {
            templateDataToReturn.dueDate = getConvertedDate(convertDateFromERPFormatToDocFormat(dataFromAPI.referenceDate), templateDataToReturn.dateFormat)
            templateDataToReturn.showDueDate = TemplateSettingsManager.defaultTemplateSettings.documentInfo.documentDetails.date.dueDate.isVisible
        }

        //line item
        templateDataToReturn.lineItems = LineItemsParser.getAccountItem(dataFromAPI, templateDataToReturn.type)

        // Set PAN and CIN for Credit Notes and Debit Notes
        if (getIsCreditNote(templateDataToReturn.type)) {
            templateDataToReturn.panNo = dataFromAPI.contactInfo?.pan ?? dataFromAPI.contactInfo?.panIndia ?? dataFromAPI.contact?.pan ?? dataFromAPI.contact?.panIndia ?? ''
            templateDataToReturn.cinNo = dataFromAPI.contactInfo?.cin ?? dataFromAPI.contactInfo?.cinIndia ?? dataFromAPI.contact?.cin ?? dataFromAPI.contact?.cinIndia ?? ''
        }
        else if (getIsDebitNote(templateDataToReturn.type)) {
            // For Debit Notes: PAN and CIN should be from tenant (company) details
            templateDataToReturn.panNo = dataFromAPI.tenantInfo?.panIndia ?? ''
            templateDataToReturn.cinNo = dataFromAPI.tenantInfo?.cinIndia ?? ''
        }

        //location
        templateDataToReturn = TenantParser.parseLocationDetail(dataFromAPI, templateDataToReturn)

        if (getIsDebitOrCreditNote(templateDataToReturn.type)) {
            templateDataToReturn = this.getEInvoiceDetails(dataFromAPI, templateDataToReturn)

            //add additional product table line item if 
            if(dataFromAPI.productLineItems && dataFromAPI.productLineItems.length > 0) {
                let productLineItems = dataFromAPI.productLineItems.filter(x => x.quantity > 0)
                templateDataToReturn.productLineItems = LineItemsParser.getProductLineItem(dataFromAPI, false, dataFromAPI.dateFormat, productLineItems)
            }
            

            var linkDocumentNumber = undefined
            var linkDocumentType = undefined
            if(dataFromAPI.salesInvoiceCode !== undefined && dataFromAPI.salesInvoiceCode !== null) {
                linkDocumentNumber = dataFromAPI.salesInvoiceCode
                linkDocumentType = 'invoice'
            }
            else if(dataFromAPI.purchaseInvoiceCode !== undefined && dataFromAPI.purchaseInvoiceCode !== null) {
                linkDocumentNumber = dataFromAPI.purchaseInvoiceCode
                linkDocumentType = 'purchase order'
            }

            templateDataToReturn.linkDocumentNumber = linkDocumentNumber
            templateDataToReturn.linkDocumentType = linkDocumentType

            if(getIsCreditNote(templateDataToReturn.type)) {
                templateDataToReturn = this.getCreditNoteBillToAndShipToAddress(dataFromAPI, templateDataToReturn)
            }
            else if(getIsDebitNote(templateDataToReturn.type)) {
                templateDataToReturn = this.getDebitNoteBillToAndShipToAddress(dataFromAPI, templateDataToReturn)
            }

        }
        return templateDataToReturn
    }

    static get_CN_DN_Payment_Detail(data) {
        if (data && data.accountName !== undefined && data.accountName !== null) {
            var detailString = ''
            detailString = data.accountName + '\n'
            if (data.paymentType !== null && data.paymentType !== undefined && data.accountName?.toLowerCase() !== data.paymentType?.toLowerCase()) {
                detailString = detailString + Utility.getPaymentMethod(data.paymentType, data.country)
            }
            if (data.referenceNumber !== undefined && data.referenceNumber !== null && data.referenceNumber !== '') {
                detailString = detailString + ' (' + data.referenceNumber + ') \n'
            }
            return detailString
        }
    }

    static getEInvoiceDetails(dataFromAPI, templateDataToReturn) {
        //add E invoice data
        templateDataToReturn.irn = dataFromAPI.irn
        templateDataToReturn.ackDt = dataFromAPI.ackDt
        templateDataToReturn.ackNo = dataFromAPI.ackNo
        templateDataToReturn.signedQRCode = dataFromAPI.signedQRCode
        //update handling for cancelled e-invoice
        templateDataToReturn.eInvoiceStatus = dataFromAPI.einvoiceStatus ?? ''
        templateDataToReturn.eInvoice = {
            irn: dataFromAPI.irn,
            ackDt: dataFromAPI.ackDt,
            ackNo: dataFromAPI.ackNo,
            signedQRCode: dataFromAPI.signedQRCode
        }
        if (TemplateSettingsManager.defaultTemplateSettings.documentInfo.documentDetails.eInvoiceSection === undefined) {
            TemplateSettingsManager.defaultTemplateSettings.documentInfo.documentDetails['eInvoiceSection'] = { 'isVisible': false }
        }
        else {
            templateDataToReturn.showEInvoiceSection = TemplateSettingsManager.defaultTemplateSettings.documentInfo.documentDetails.eInvoiceSection.isVisible
            if (templateDataToReturn.signedQRCode === undefined || templateDataToReturn.signedQRCode === null || templateDataToReturn.signedQRCode === '') {
                templateDataToReturn.showEInvoiceSection = false
            }
        }
        return templateDataToReturn
    }

    static getCreditNoteBillToAndShipToAddress(dataFromAPI, templateDataToReturn) {
        if(dataFromAPI.billToAddress !== undefined && dataFromAPI.billToAddress !== null) {
            var clientBillToAddressObj = new Address(dataFromAPI.contactInfo.name, dataFromAPI.billToAddress, dataFromAPI.contactInfo.pan, dataFromAPI.contactInfo.gstin, dataFromAPI.contactInfo.contactNumber, dataFromAPI.contactInfo.documentSequenceCode, OwnerType.contact)
            // Set PAN and CIN for bill to address
            clientBillToAddressObj.panIndia = dataFromAPI.contactInfo?.pan ?? ''
            clientBillToAddressObj.cinIndia = dataFromAPI.contactInfo?.cin ?? ''
            templateDataToReturn.clientBillToAddressObj = clientBillToAddressObj
            templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.billTo, templateDataToReturn)
        }
        
        if(dataFromAPI.shipToAddress !== undefined && dataFromAPI.shipToAddress !== null) {
            var clientShipToAddressObj = new Address(dataFromAPI.contactInfo.name, dataFromAPI.shipToAddress, dataFromAPI.contactInfo.pan, dataFromAPI.contactInfo.gstin, dataFromAPI.contactInfo.contactNumber, dataFromAPI.contactInfo.documentSequenceCode, OwnerType.contact)
            // Set PAN and CIN for ship to address
            clientShipToAddressObj.panIndia = dataFromAPI.contactInfo?.pan ?? ''
            clientShipToAddressObj.cinIndia = dataFromAPI.contactInfo?.cin ?? ''
            templateDataToReturn.clientShipToAddressObj = clientShipToAddressObj
            templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.shipTo, templateDataToReturn)
        }
        templateDataToReturn = this.updateCreditAndDebitNoteTemplateSetting(templateDataToReturn)
        return templateDataToReturn
    }

    static getDebitNoteBillToAndShipToAddress(dataFromAPI, templateDataToReturn) {
        // For Debit Notes: Bill To should be tenant (company) details
        if(dataFromAPI.billToAddress !== undefined && dataFromAPI.billToAddress !== null) {
            var clientBillToAddressObj = new Address(dataFromAPI.companyName, dataFromAPI.billToAddress, dataFromAPI.pan, dataFromAPI.tenantInfo.gstin, dataFromAPI.tenantInfo.contactNumber, undefined, OwnerType.tenant)
            // Set PAN and CIN for bill to address (tenant details)
            clientBillToAddressObj.panIndia = dataFromAPI.tenantInfo?.panIndia ?? ''
            clientBillToAddressObj.cinIndia = dataFromAPI.tenantInfo?.cinIndia ?? ''
            templateDataToReturn.clientBillToAddressObj = clientBillToAddressObj
            templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.billTo, templateDataToReturn)
        }
        
        // For Debit Notes: Ship To should be contact details
        if(dataFromAPI.shipToAddress !== undefined && dataFromAPI.shipToAddress !== null) {
            var clientShipToAddressObj = new Address(dataFromAPI.contactInfo.name, dataFromAPI.shipToAddress, dataFromAPI.contactInfo.pan, dataFromAPI.contactInfo.gstin, dataFromAPI.contactInfo.contactNumber, dataFromAPI.contactInfo.documentSequenceCode, OwnerType.contact)
            // Set PAN and CIN for ship to address (contact details)
            clientShipToAddressObj.panIndia = dataFromAPI.contactInfo?.pan ?? ''
            clientShipToAddressObj.cinIndia = dataFromAPI.contactInfo?.cin ?? ''
            templateDataToReturn.clientShipToAddressObj = clientShipToAddressObj
            templateDataToReturn = AddressParser.assignAddressObjToStringForNonArabic(undefined, AddressType.shipTo, templateDataToReturn)
        }
        templateDataToReturn = this.updateCreditAndDebitNoteTemplateSetting(templateDataToReturn)
        return templateDataToReturn
    } 

    static updateCreditAndDebitNoteTemplateSetting(templateDataToReturn) {
        if(templateDataToReturn.clientShipToAddressObj !== undefined) {
            let shipToTitle = TemplateSettingsManager.defaultTemplateSettings.documentInfo.clientAddresses.shipToDetails.title
            let showClientShipToAddress = TemplateSettingsManager.defaultTemplateSettings.documentInfo.clientAddresses.shipToDetails.isVisible
            if(shipToTitle === '' && showClientShipToAddress === false) {
                templateDataToReturn.showClientShipToAddress = true
                templateDataToReturn.billToTitle = getLocalisedText('bill_to')
                TemplateSettingsManager.updateBillToTitle(getLocalisedText('bill_to'))
                templateDataToReturn.shipToTitle = getLocalisedText('ship_to')
                TemplateSettingsManager.updateShipToTitle(getLocalisedText('ship_to'))
            }
        }

        return templateDataToReturn
    }
}
